import type {SuggestLocation} from '@yandex-delivery/api/model/suggest'

export const getGeolocationFromBrowser = (): Promise<SuggestLocation> =>
  new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      ({coords}) => {
        resolve([coords.longitude, coords.latitude])
      },
      reject,
      {
        enableHighAccuracy: true,
        maximumAge: 0,
        timeout: 2000,
      },
    )
  })
